export const NOT_FOUND = 'Not found'
export const SEARCH_ITEMS_COUNT = 5
